import React, { useEffect, useState } from "react";
import Accordion from "react-bootstrap/Accordion";
import ViewProfileAccordion from "./viewProfileAccordion";

function ProfilesAccordion({ profilesData }) {
	return (
		<div className="profile-accordion">
			<Accordion defaultActiveKey="0">
				{profilesData?.map((item, index) => {
					return (
						<Accordion.Item eventKey={index}>
							<Accordion.Header>
								<div className="d-flex justify-content-between align-items-center w-100">
									<div className="d-flex gap-3 align-items-center justify-content-between w-100">
										<h6 className="fw-700">
											{(item?.first_name && item.first_name !== "hidden") ||
											(item?.last_name && item.last_name !== "hidden") ? (
												<span className="tetx-blue-card">
													{item?.first_name && item.first_name !== "hidden"
														? item.first_name
														: "First Name"}{" "}
													{item?.last_name && item.last_name !== "hidden"
														? item.last_name
														: "Last Name"}
												</span>
											) : (
												<span className="tetx-blue-card">
													{item?.profile_id}
												</span>
											)}
										</h6>

										<div className="d-flex pr-30">
											<img
												src={
													item?.profile === "groom"
														? `../../assets/images/bat-img/profile-male.svg`
														: `../../assets/images/bat-img/profile-female.svg`
												}
												title={item?.profile === "groom" ? "Groom" : "Bride"}
												style={{ width: "33px" }}
											/>
											<img
												style={{ width: "30px" }}
												src={
													item?.payment_status === "active"
														? `../../assets/images/bat-img/payment-done.svg`
														: `../../assets/images/bat-img/payment-failed.svg`
												}
												title={
													item?.payment_status === "active"
														? "Payment Done"
														: "Payment Pending"
												}
												className="ml-10"
											/>
										</div>
									</div>
								</div>
							</Accordion.Header>
							<Accordion.Body className="toggle-profile-data-grid-responive-body">
								<ViewProfileAccordion profileData={item} />
							</Accordion.Body>
						</Accordion.Item>
					);
				})}
			</Accordion>
		</div>
	); //: (
	// 	"Profile not found"
	// );
}

export default ProfilesAccordion;
